import { graphql } from '@teachino/shared-infrastructure';

export const renameTopicMutation = graphql(`
  mutation RenameTopic($id: String!, $name: String!) {
    updateTopic(updateTopicInput: { id: $id, name: $name }) {
      topic {
        __typename
        id
        name
      }
    }
  }
`);
